@file:OptIn(ExperimentalMaterial3Api::class)

package com.wintermar.inspection.feature.presentation.template.landing

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.SheetState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.component.modal.ModalDialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalActionModel
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateModel
import com.wintermar.inspection.feature.presentation.template.landing.widget.TemplateLandingHeader
import com.wintermar.inspection.feature.presentation.template.landing.widget.TemplateLandingPageHeader
import com.wintermar.inspection.feature.presentation.template.landing.widget.item.TemplateLandingItemWide
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.preview_template
import org.jetbrains.compose.resources.stringResource

@Composable
actual fun TemplatePreviewContent(
    sheetState: SheetState,
    show: Boolean,
    isLoading: Boolean,
    action: ModalActionModel,
    onDismiss: () -> Unit,
    content: @Composable ((topPadding: Dp) -> Unit)
) {
    ModalDialog(
        show = show,
        isLoading = isLoading,
        title = stringResource(Res.string.preview_template),
        action = action.copy(
            withBackgroundHeader = true,
            widthButtonBasedOnText = true,
        ),
        onDismiss = onDismiss,
        content = { verticalPadding ->
            content(verticalPadding)
        }
    )
}

actual fun LazyListScope.itemContent(
    data: List<InspectionTemplateModel>,
    color: ThemeColor,
    dimension: AppDimension,
    onClick: (templateId: String) -> Unit
) {
    stickyHeader {
        TemplateLandingHeader()
    }

    items(data) {
        TemplateLandingItemWide(
            data = it,
            onClick = onClick
        )
    }
}

@Composable
actual fun HeaderContent() {
    TemplateLandingPageHeader()
}

@Composable
actual fun ContentContainer(
    paddingValues: PaddingValues,
    color: ThemeColor,
    dimension: AppDimension,
    content: @Composable (ColumnScope.() -> Unit)
) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(
                bottom = paddingValues.calculateBottomPadding()
            )
    ) {
        content()
    }
}
